import { render, staticRenderFns } from "./ErrorMain.vue?vue&type=template&id=1f45cf3a&scoped=true"
import script from "./ErrorMain.vue?vue&type=script&lang=js"
export * from "./ErrorMain.vue?vue&type=script&lang=js"
import style0 from "./ErrorMain.vue?vue&type=style&index=0&id=1f45cf3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f45cf3a",
  null
  
)

export default component.exports